<template>
  <div class="d-flex flex-sm-row flex-wrap pa-3 gap-2">
    <!-- Group by -->
    <div class="d-flex flex-wrap gap-2">
      <span>Agrupar por :</span>
      <div class="wx-150">
        <custom-gray-select
          v-model="group"
          :disabled="disabled"
          :options="roleHierarchy"
          class="w-100"
        />
      </div>
    </div>

    <!-- Period -->
    <div class="d-flex flex-wrap gap-2">
      <span>Periodo:</span>
      <div class="wx-150">
        <custom-gray-select
          v-model="period"
          :disabled="disabled"
          :options="periodOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import MixinService from '@/mixins/service';
  import MixinHelpers from '@/mixins/helpers';
  import MixinDates from '@/mixins/dates';
  import { Roles, MetaRoles } from '@/core/constants/roleConstants';

  import CustomGraySelect from '@/components/CustomGraySelect.vue';

  export default {
    name: 'GroupByMenu',
    components: { CustomGraySelect },

    mixins: [MixinService, MixinHelpers, MixinDates],
    props: {
      disabled: {
        type: Boolean,
      },
    },
    data: () => ({
      months: [],
      periodOptions: [],
      period: null,
      roleHierarchy: [],
      group: null,
    }),

    computed: {
      ...mapGetters({
        authenticated: 'auth/authenticated',
        user: 'auth/user',
      }),
      optionPeriods() {
        return this.arrayPluck(this.months, 'date');
      },
    },

    watch: {
      group(newValue, oldValue) {
        if (newValue && newValue.value !== oldValue?.value) this.emitChange();
      },
      period() {
        this.emitChange();
      },
    },

    created() {
      this.months = this.calcularUltimosMeses(13);
      this.setRoleHierarchy();
      this.setPeriodOptions();
    },

    methods: {
      emitChange() {
        this.$emit('change', {
          groupBy: this.group.value,
          period: this.period.value,
          headerTitle: this.group.label,
        });
      },

      setRoleHierarchy() {
        const config = this.getRoleHierarchyWithMetadata();
        this.roleHierarchy = config;
        this.group = this.roleHierarchy[0] || null;
      },

      setPeriodOptions() {
        this.periodOptions = this.months.map((el) => ({
          label: el.date,
          value: `${el.year}${String(el.month).padStart(2, '0')}`,
        }));
        this.period = this.periodOptions[0];
      },

      getRoleHierarchyWithMetadata() {
        const regionalManager = {
          label: 'Territorial',
          value: Roles.REGIONAL_MANAGER,
        };
        const manager = { label: 'Gerencia', value: Roles.MANAGER };
        const seller = { label: 'Asesor', value: Roles.SELLER };
        const metaRole = this.$route.meta.role;

        switch (metaRole) {
          case MetaRoles[Roles.DIRECTOR]:
          case MetaRoles[Roles.SUB_DIRECTOR]:
            return [regionalManager, manager, seller];
          case MetaRoles[Roles.REGIONAL_MANAGER]:
            return [manager, seller];
          default:
            return [];
        }
      },
    },
  };
</script>
